﻿import { PredictionResultTimestep } from "./PredictionResultTimestep";
import { Duration } from "moment";

export class PredictionResult {
    public Timesteps: PredictionResultTimestep[] = [];
    constructor(public Id: number, public Timestart: Date, public Timeinterval: Duration, public ExternalId: number, public RasterType: string, public CreationDate: Date) {
    }
}